window.GoogleAnalyticsObject = "ga";
window.ga = function () {
	(window.ga.q = window.ga.q || []).push(arguments);
};
window.ga.l = 1 * new Date();

if(window.location.host.indexOf('cootekservice') > 0){
	ga('create', 'UA-44448382-2', 'cootekservice.com');
}else{
	ga('create', 'UA-44448382-3', 'cootek.com');
}
window.ga("send", "pageview");

export default function () {
	window.ga.apply(this, arguments);
};



/** WEBPACK FOOTER **
 ** ./src/scripts/basic/ga.js
 **/